import axios from 'axios'
import { b64Md5 } from '@/lib/md5'

axios.defaults.withCredentials = true
const flieUpload = {
  methods: {
    // 文件 类型 转换
    convertUint8ArrayToBinaryString(u8Array) {
      let i
      const len = u8Array.length
      let bStr = ''
      for (i = 0; i < len; i++) {
        bStr += String.fromCharCode(u8Array[i])
      }

      return bStr
    },
    fileToMd5(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsArrayBuffer(file)
        fileReader.onload = () => {
          const fileReaderResult = fileReader.result
          const bytes = new Uint8Array(fileReaderResult)
          const u8ArrayStr = this.convertUint8ArrayToBinaryString(bytes)
          const fileMd5 = b64Md5(u8ArrayStr)
          console.log('异步1：文件类型转换')
          resolve({ fileReaderResult, fileMd5 })
        }
      })
    },
    async fileChange(file) {
      try {
        const { name, size, type, progress } = file
        const { fileReaderResult, fileMd5 } = await this.fileToMd5(file)
        const uploadOssOptions = {
          contentMd5: fileMd5,

          // 如果文件是 pdf 就用 'application/pdf'，其他就用 默认的
          contentType: type === 'application/pdf' ? type : 'application/octet-stream',
          fileName: name,
          fileSize: size,
          convert2Pdf: type === 'application/pdf' ? false : true,
        }

        // 上传到 oss 结果
        const { data } = await this.$Http.api({
          url: 'webserver/v1/files/getUploadUrl',
          method: 'POST',
          body: uploadOssOptions,
        })

        const { fileId, uploadUrl } = data
        await this.uploadOss(file, fileMd5, uploadUrl, type)

        return { name, type, fileId, uploadUrl }
      } catch (e) {
        console.log(e)

        return { name: '', type: '', fileId: '', uploadUrl: '' }
      }
    },

    // 直传到oss
    uploadOss(file, fileMd5, uploadUrl, ContentType, realContentType) {
      console.log('ContentType', ContentType)
      const type = realContentType ? realContentType : ContentType === 'application/pdf' ? 'application/pdf' : 'application/octet-stream'
      const requsetHeaders = { 'Content-MD5': fileMd5, 'Content-Type': type }
      let progress = ''

      return axios({
        headers: requsetHeaders,
        url: uploadUrl,
        method: 'put',
        data: file,
        onUploadProgress: this.onUploadProgress(res => {
          progress = res
        }),
      })
        .then(res => {
          console.log('异步3：oss 上传成功', res)

          return {
            progress,
            okOss: true,
          }
        })
        .catch(() => {
          return {
            progress,
            okOss: false,
          }
        })
    },

    // 进度条
    onUploadProgress(callProgress = function() {}) {
      return progressEvent => {
        const { total } = progressEvent
        const { loaded } = progressEvent
        const progress = Math.floor((loaded / total) * 100)
        callProgress(progress)
      }
    },
  },
}

export default flieUpload
